export default __webpack_public_path__ + "static/media/217.621f63d6.jpg";